module.exports = __webpack_public_path__ + "static/media/Oscar.0f253e0b.png";